import "./NewProfile.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaBell, FaBellSlash } from "react-icons/fa";
import { MdOutlineDiamond } from "react-icons/md";
import { Tooltip } from "primereact/tooltip";
import Cookies from "js-cookie";
import { useLazyQuery, useSuspenseQuery } from "@apollo/client";
import { GET_ALL_MODEL_CODES, GET_NOTIFICATION_ENABLED_CODE } from "../../graphql/liveQuery/queries";
import { getUserMail } from "../../services/util/getUserMail";
import { getPrivilegeObject, isNotificationEnabled } from "../../services/util/util";
import { getNotificationStatus, updateAll } from "../../api/otherEndPoints/userprofile";
import { getPrivilegedCodeAndSymbol } from "../../api/otherEndPoints/necessoryEndPoints";
import { setNotifyStatus } from "../../store/notifySlice";
import { getModelWiseParams } from "../../services/util/backdatedParams";
import moment from "moment";


const NewProfile = () => {
  const dispatch = useDispatch();
  const [privileges, setPrivileges] = useState<any>([]);
  const [modeWiselCheckBoxArr, setModelWiseCheckBoxArr] = useState<any>();
  const [isEnabled, setIsEnabled] = useState(false);
  const [notifState, setNotifState] = useState<any>({})
  const [privilegedCodeAndSymbol, setPrivilegedCodeAndSymbol] = useState<any>([]);



  const { error, data }: any = useSuspenseQuery(GET_ALL_MODEL_CODES, {
    variables: { userName: getUserMail() },
  })

  const userDetailsCookies: any = Cookies.get("details");
  const userDataParsed: any = userDetailsCookies
    ? JSON.parse(userDetailsCookies)
    : { email: "", expiry: "", userName: "", isLoggedIn: false };

  const privilegeDataSelector: any = useSelector((state: any) => {
    return state.privilege.privilege;
  });

  const deletedPrivilege: any = useSelector((state: any) => {
    return state.privilege.deletedPrivilege;
  });

  useEffect(()=>{
    setIsEnabled(isNotificationEnabled())
  })

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    try{
        (async function fetchCodeAndSymbol(){
            let codeAndSymbol:any = await getPrivilegedCodeAndSymbol();
            if(!codeAndSymbol.error) setPrivilegedCodeAndSymbol(codeAndSymbol?.data);
            else setPrivilegedCodeAndSymbol([]);
        })();
    }catch(e){
        console.log("Error when try to get privilege code and symbol",e);
    }
  }, [privilegeDataSelector, deletedPrivilege])


  const handleToggle = () => {
    localStorage.setItem('notificationEnabled', JSON.stringify(!isEnabled))
    setIsEnabled(!isEnabled);
    const updatedModeWiselCheckBoxArr = Object.keys(modeWiselCheckBoxArr).reduce((item:any, key:any) => {
      item[key] = modeWiselCheckBoxArr[key].map((item: any) => {
        // Create a new object by spreading the existing item and updating isActive

        return {
          ...item,
          isActive: !isEnabled
        };
      });
      return item;
    }, {});
    console.log("pri",updatedModeWiselCheckBoxArr);
    
    setModelWiseCheckBoxArr(updatedModeWiselCheckBoxArr);
    dispatchNotificationStatus({ variables: { userName: userDataParsed?.email } })
    updateAll( userDataParsed?.email, !isEnabled).then((res: any) => {
      if (res) {
          // console.log("result true")
      }
  })

  };

  const disableBtn = async (s_code: any, tradeCode: any) => {
    let newData: any = {}
    let boolState:any = false

    setModelWiseCheckBoxArr((prevState: any) => {
      // Create a copy of the current state
      newData = { ...prevState };

      // Loop over FNO and LFT, ... arrays to toggle the isActive state
      Object.keys(newData).forEach((key) => {
        newData[key] = newData[key].map((item: any) => {
          // Check if the s_code and tradeCode match and toggle isActive
          if (item?.s_code === s_code && item?.tradeCode === tradeCode) {
            boolState = !item.isActive;
            return { ...item, isActive: !item.isActive };
          }
          return item;
        });
      });
      return newData;
    });
    await getNotificationStatus(s_code, userDataParsed?.email, boolState).then((res: any) => {
      if (res) {
          // setNotifState(!updatedresponse)
      }
  })
  let getNotifCodes: any = dispatchNotificationStatus({ variables: { userName: userDataParsed?.email } })
  };

  let returnReferenceObj: any = {
    'IOI': 'FNO',
    'SOI': 'FNO',
    'ESM': 'EQ',
    'EBM': 'eqN50BANK',
    'AIOBANDDI': 'FNO',
    'AIONIFDDI': 'FNO',
    'IFI': 'FNO',
    'SFI': 'FNO',
    'CFI': 'FNO',
    'AIONIFKKI': 'OPTLONG'
  }

  const [notificationCodes, result] = useLazyQuery(GET_NOTIFICATION_ENABLED_CODE, {
    fetchPolicy: "network-only",
    onCompleted: (data: any) => {
      try {
        let res: any = data?.notificationCodes;
        setNotifState((prevState: any) => ({ ...prevState, ...res }));
        const payload:any = {
          notificationCodes: res // Wrap the array in an object
        };
        dispatch(setNotifyStatus(payload))
        return data?.notificationCodes;
      } catch (error) {
        console.log("getnotif Error while fetching from graphql...", error)
      }
    }
  })

  const [dispatchNotificationStatus, {}] = useLazyQuery(GET_NOTIFICATION_ENABLED_CODE, {
    fetchPolicy: "network-only",
    onCompleted: (data: any) => {
      try {
        let res: any = data?.notificationCodes;
        const payload:any = {
          notificationCodes: res // Wrap the array in an object
        };
        dispatch(setNotifyStatus(payload))
        return data?.notificationCodes;
      } catch (error) {
        console.log("getnotif Error while fetching from graphql...", error)
      }
    }
  })

  useEffect(() => {
    // let getNotifCodes: any = notificationCodes({ variables: { userName: userDataParsed?.email } })
    let boolRes: any = false
    modeWiselCheckBoxArr?.FNO?.map((item: any, index: any) => { if (item?.value === 'subscribed') (boolRes = boolRes | item?.isActive) })
    modeWiselCheckBoxArr?.EQ?.map((item: any, index: any) => { if (item?.value === 'subscribed') (boolRes = boolRes | item?.isActive) })
    modeWiselCheckBoxArr?.LFT?.map((item: any, index: any) => { if (item?.value === 'subscribed') (boolRes = boolRes | item?.isActive) })
    modeWiselCheckBoxArr?.OPTLONG?.map((item: any, index: any) => { if (item?.value === 'subscribed') (boolRes = boolRes | item?.isActive) })
    if (boolRes) {
      setIsEnabled(true)
    }
    else {
      setIsEnabled(false)
    }
  }, [modeWiselCheckBoxArr])



  useEffect(() => {
    let getNotifCodes: any = notificationCodes({ variables: { userName: userDataParsed?.email } })
    async function runGetPrivilegeObject() {
      await getPrivilegeObject(data?.allCodes)
    }
    runGetPrivilegeObject()
    let tempvalue: any = localStorage.getItem('modelWiseValue');
    tempvalue = JSON.parse(tempvalue)
    setModelWiseCheckBoxArr(tempvalue)
  }, [])

  useEffect(() => {
    let userPrivilegesCode: any = Cookies.get("codesArray");
    let parsedUserPrivilegesCode: any = Cookies.get("codesArray")
      ? JSON.parse(userPrivilegesCode)
      : [];
    setPrivileges(parsedUserPrivilegesCode);

    // let tree:any = Cookies.get('modelTreeCheckBox')

    // setModelTreeCheckBoxArr(JSON.parse(tree))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [privilegeDataSelector, deletedPrivilege]);

  useEffect(() => {
    setNotifState(notifState);

    // Check if both notifState and modeWiselCheckBoxArr are not empty
    if (Object.keys(notifState).length !== 0 && Object.keys(modeWiselCheckBoxArr).length !== 0) {
      // Iterate through each item in notifState
      Object.values(notifState).forEach((item1: any) => {
        let title_name: any;

        // Determine the title_name based on the s_code
        if (item1?.s_code !== 'AIOBANDDI' && item1?.s_code !== 'AIONIFDDI') {
          title_name = (item1?.s_code === 'AIONIFKKI' ? 'OPTLONG' :
            item1?.s_code.slice(0, 3) === 'QEB' ? 'FNO' :
              returnReferenceObj[item1?.s_code.slice(1, 3) + item1?.s_code.slice(-1)]);
        } else {
          title_name = 'LFT';
        }

        // Check if title_name exists in modeWiselCheckBoxArr
        if (modeWiselCheckBoxArr[title_name]) {
          modeWiselCheckBoxArr[title_name].forEach((item2: any) => {
            if (item1?.s_code === item2?.s_code) {
              item2.isActive = item1.s_notificationenabled === "true"; // Convert string to boolean
            }
          });
        }
      });

      // Update the state with the modified modeWiselCheckBoxArr
      setModelWiseCheckBoxArr((prevState: any) => ({ ...prevState, ...modeWiselCheckBoxArr }));
    }
  }, [notifState]);


  return (

    <div className="mainProfileDiv">
      <div className="profileCard">
        <div className="profilePhoto">
          <img
            src="svgImage/icons8-user-icon-96.png"
            className="profileImg"
            alt="Profile"
          />
        </div>
        <span>
          <h2>{userDataParsed?.userName?.toUpperCase()}</h2>
        </span>
        <span>
          <h4>{userDataParsed?.email}</h4>
        </span>
        <span>
          <h4>
            {userDataParsed?.expiry !== null || userDataParsed?.expiry !== ""
              ? "Subscription valid till"
              : ""}{" "}
            <span className="date"> {moment(userDataParsed?.expiry).format("DD MMM YYYY")}
            </span>
          </h4>
        </span>
        {/* <ModelTreeCheckBox /> */}

        {/* toggle notification button */}


        <Tooltip target=".miniIcon" style={{ fontSize: '12px', cursor: 'pointer' }} /> 
        <Tooltip target=".miniIcon_disable" style={{ fontSize: '12px', cursor: 'pointer' }} />




        <div className="profileDetail ">
          <div className="toggle-container" onClick={handleToggle}>
            <div
              className={`toggle-switch ${isEnabled ? "enabled" : "disabled"}`}
            >
              <div
                className={`toggle-circle ${isEnabled ? "slide-right" : "slide-left"
                  }`}
              >
                {isEnabled ? (
                  <FaBell className="icon" />
                ) : (
                  <FaBellSlash className="icon" />
                )}
              </div>
            </div>
          </div>
          <div className="privilegeSection">

            {/* FNO */}
            <div className="afterPriviledge">
              <div className="PrivName">OPT S</div>

              <div className="PriviledgeGrid">
                <div className="priviledgeBox">
                  {modeWiselCheckBoxArr?.FNO?.map((item: any, index: any) => {
                    if((item?.s_code)?.slice(1,3)==='IO'){
                    return (
                      <button
                        className={`${item?.value === 'subscribed' ? isEnabled ? "item" : "item" : 'item_disbled'}`}
                        disabled={item?.value === 'subscribed' ? false : true}
                        key={index}
                        onClick={() => { disableBtn(item?.s_code, item?.tradeCode) }}>
                        <span>{getModelWiseParams(item?.s_code)}</span>
                        {item?.value === 'subscribed' ? (

                          item?.isActive ? (
                            <FaBell size={18} className="miniIcon"
                              data-pr-tooltip="Notification enable"
                              data-pr-position="right"
                              data-pr-at="right+5 top"
                              data-pr-my="left center-2" />
                          )
                            : (
                              <FaBellSlash size={18} className="miniIcon"
                                data-pr-tooltip="Notification disable"
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2" />
                            )


                        ) : (
                          <MdOutlineDiamond size={18} className="miniIcon_disable"
                            data-pr-tooltip="Subscription required"
                            data-pr-position="right"
                            data-pr-at="right+5 top"
                            data-pr-my="left center-2"

                          />
                        )}
                      </button>
                    );}
                  })}
                </div>
              </div>
            </div>
            <hr />
            {/* LFT */}
            <div className="afterPriviledge">
              <div className="PrivName">OPT S LFT</div>

              <div className="PriviledgeGrid">
                <div className="priviledgeBox">
                  {modeWiselCheckBoxArr?.LFT?.map((item: any, index: any) => {
                    return (
                      <button
                        className={`${item?.value === 'subscribed' ? isEnabled ? "item" : "item" : 'item_disbled'}`}
                        disabled={item?.value === 'subscribed' ? false : true}
                        key={index}
                        onClick={() => { disableBtn(item?.s_code, item?.tradeCode) }}>
                        <span>{getModelWiseParams(item?.s_code)}</span>
                        {item?.value === 'subscribed' ? (

                          item?.isActive ? (
                            <FaBell size={18} className="miniIcon"
                              data-pr-tooltip="Notification enable"
                              data-pr-position="right"
                              data-pr-at="right+5 top"
                              data-pr-my="left center-2" />
                          )
                            : (
                              <FaBellSlash size={18} className="miniIcon"
                                data-pr-tooltip="Notification disable"
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2" />
                            )


                        ) : (
                          <MdOutlineDiamond size={18} className="miniIcon_disable"
                            data-pr-tooltip="Subscription required"
                            data-pr-position="right"
                            data-pr-at="right+5 top"
                            data-pr-my="left center-2" />
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
            <hr />
            {/* EQ N50 */}
            <div className="afterPriviledge">
              <div className="PrivName">EQ N50</div>

              <div className="PriviledgeGrid">
                <div className="priviledgeBox">
                  {modeWiselCheckBoxArr?.EQ?.sort((a:any, b:any)=>{
                    // console.log("sort value a and b:",a,'--',b)
                      let code1:any = a?.s_code?.substring(3,6);
                      let code2:any = b?.s_code?.substring(3,6);
                      return code1?.localeCompare(code2)
                    })?.map((item: any, index: any) => {
                    return (
                      <button
                        className={`${item?.value === 'subscribed' ? isEnabled ? "item" : "item" : 'item_disbled'}`}
                        disabled={item?.value === 'subscribed' ? false : true}
                        key={index}
                        onClick={() => { disableBtn(item?.s_code, item?.tradeCode) }}>
                        <span>{privilegedCodeAndSymbol[item?.s_code]}</span>
                        {item?.value === 'subscribed' ? (
                          item?.isActive ? (
                            <FaBell size={18} className="miniIcon"
                              data-pr-tooltip="Notification enable"
                              data-pr-position="right"
                              data-pr-at="right+5 top"
                              data-pr-my="left center-2" />
                          )
                            : (
                              <FaBellSlash size={18} className="miniIcon"
                                data-pr-tooltip="Notification disable"
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2" />
                            )


                        ) : (
                          <MdOutlineDiamond size={18} className="miniIcon_disable"
                            data-pr-tooltip="Subscription required"
                            data-pr-position="right"
                            data-pr-at="right+5 top"
                            data-pr-my="left center-2" />
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
            <hr />
            {/* EQ NEXT50 */}
            <div className="afterPriviledge">
              <div className="PrivName">EQ BANK</div>

              <div className="PriviledgeGrid">
                <div className="priviledgeBox">
                  {modeWiselCheckBoxArr?.FNO?.sort((a:any, b:any)=>{
                        // console.log("sort value a and b:",a,'--',b)
                        let code1:any = a?.s_code?.substring(3,6);
                        let code2:any = b?.s_code?.substring(3,6);
                        return code1?.localeCompare(code2)
                      })?.map((item: any, index: any) => {
                    if((item?.s_code)?.slice(0,3)==='QEB'){
                    return (
                      <button
                        className={`${item?.value === 'subscribed' ? isEnabled ? "item" : "item" : 'item_disbled'}`}
                        disabled={item?.value === 'subscribed' ? false : true}
                        key={index}
                        onClick={() => { disableBtn(item?.s_code, item?.tradeCode) }}>
                        <span>{item?.s_code?.slice(3)}</span>
                        {item?.value === 'subscribed' ? (

                          item?.isActive ? (
                            <FaBell size={18} className="miniIcon"
                              data-pr-tooltip="Notification enable"
                              data-pr-position="right"
                              data-pr-at="right+5 top"
                              data-pr-my="left center-2" />
                          )
                            : (
                              <FaBellSlash size={18} className="miniIcon"
                                data-pr-tooltip="Notification disable"
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2" />
                            )


                        ) : (
                          <MdOutlineDiamond size={18} className="miniIcon_disable"
                            data-pr-tooltip="Subscription required"
                            data-pr-position="right"
                            data-pr-at="right+5 top"
                            data-pr-my="left center-2" />
                        )}
                      </button>
                    );}
                  })}
                </div>
              </div>
            </div>
            <hr />

            {/* OPT LONG */}
            <div className="afterPriviledge">
              <div className="PrivName">OPT L</div>

              <div className="PriviledgeGrid">
                <div className="priviledgeBox">
                  {modeWiselCheckBoxArr?.OPTLONG?.map((item: any, index: any) => {
                    return (
                      <button
                        className={`${item?.value === 'subscribed' ? isEnabled ? "item" : "item" : 'item_disbled'}`}
                        disabled={item?.value === 'subscribed' ? false : true}
                        key={index}
                        onClick={() => { disableBtn(item?.s_code, item?.tradeCode) }}>
                        {getModelWiseParams(item?.s_code)}
                        {item?.value === 'subscribed' ? (

                          item?.isActive ? (
                            <FaBell size={18} className="miniIcon"
                              data-pr-tooltip="Notification enable"
                              data-pr-position="right"
                              data-pr-at="right+5 top"
                              data-pr-my="left center-2" />
                          )
                            : (
                              <FaBellSlash size={18} className="miniIcon"
                                data-pr-tooltip="Notification disable"
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2" />
                            )


                        ) : (
                          <MdOutlineDiamond size={18} className="miniIcon_disable"
                            data-pr-tooltip="Subscription required"
                            data-pr-position="right"
                            data-pr-at="right+5 top"
                            data-pr-my="left center-2" />
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          className="fontSize"
          style={{ textAlign: "center" }}
          href="mailto:admin@feedsense.ai"
        >
          To change the password, please contact the administrator.
        </a>
      </div>
    </div>

  );
};

export default NewProfile;
